export default "__VITE_ASSET__BE3r7jXT__"